export default __webpack_public_path__ + "static/media/cordova.4196ff79.png";